// React imports
import React, { useMemo } from 'react'
// Custom component imports
import Input from 'components/generic/form/Input'
import Select from 'components/generic/form/Select'
// Utility imports
import { getStatesAndProvinces, getStatesAndProvincesV2 } from 'utils/helpers'

export interface StateProvinceInputProps {
  key: string
  name: string
  defaultValue?: string
  control: any
  error: any
  'data-testid': string
  variant?: string
  size?: string
  disabled: boolean
  helperText?: string
  enableCountryCodes: boolean
  country?: string
}

const StateProvinceInput: React.FC<StateProvinceInputProps> = ({
  helperText,
  enableCountryCodes,
  country,
  ...restProps
}) => {
  const USAndCanadaStates = useMemo(() => getStatesAndProvinces(['United States', 'Canada']), [])
  const countryStates = useMemo(
    () => getStatesAndProvincesV2(country ? [country] : [], { byCode: true, removeCountryHeaders: true }),
    [country],
  )
  if (!enableCountryCodes) {
    // feature flag disabled
    return <Select label="State" items={USAndCanadaStates} {...restProps} />
  } else if (!!country && ['US', 'CA'].includes(country)) {
    // Supported countries
    return <Select label={country === 'US' ? 'State' : 'Province'} items={countryStates} {...restProps} />
  } else {
    // Currently unsupported countries, just have user type in their state/province
    return <Input label="State/Province" helperText={helperText} {...restProps} />
  }
}

export default StateProvinceInput
